import { useGetClipboardScoreProfile } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import { useIsInHomeEnabled } from "@src/appV2/redesign/InHome/lib/useIsInHomeEnabled";
import { useWorkerPendingVisitInvites } from "@src/appV2/redesign/InHome/VisitInvites/api/useWorkerPendingVisitInvites";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { parseISO } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { formatInTimeZone } from "date-fns-tz";
import { useCallback } from "react";

import { RestrictedPageContent } from "./PageContent";

export function RestrictedPage() {
  const { userId, tmz } = useDefinedWorker();
  const { data: clipboardScoreData, refetch: refetchClipboardScoreProfile } =
    useGetClipboardScoreProfile(userId);

  const isInHomeEnabled = useIsInHomeEnabled();
  const { data: visitInvitesData, refetch: refetchVisitInvites } = useWorkerPendingVisitInvites({
    options: {
      enabled: isInHomeEnabled,
    },
  });

  const invitesCount = visitInvitesData?.data?.length ?? 0;

  const refreshAllData = useCallback(async () => {
    const promises: Promise<unknown>[] = [refetchClipboardScoreProfile()];
    if (isInHomeEnabled) {
      promises.push(refetchVisitInvites());
    }
    await Promise.all(promises);
  }, [isInHomeEnabled, refetchClipboardScoreProfile, refetchVisitInvites]);

  const reEnrollmentDate = clipboardScoreData?.accountStatus?.reEnrollmentDate;
  const formattedLiftDate = reEnrollmentDate
    ? formatInTimeZone(parseISO(reEnrollmentDate), tmz, "MMM d, yyy h:mm aa")
    : undefined;

  return (
    <RestrictedPageContent
      invitesCount={invitesCount}
      liftDate={formattedLiftDate}
      onRefresh={refreshAllData}
    />
  );
}
